export class ConveyanceSellerInfoResultDto {
    sellerFullName: string;
    sellerCustomerId: string;
    sellerType: string;
}
